import React from 'react';
import { Button, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import CompanyAutocomplete from '../CompanyAutocomplete';
import { useUnifiedMutate } from '../../hooks/useUnifiedMutate';

const CompanyAssignmentModal = ({
  isOpen,
  companies,
  selectedCompany,
  numberIds,
  modalKey,
  onCompanyChange,
  onCompanyInputChange,
  onCancel,
  onAssigned,
}) => {
  const { mutate, isLoading } = useUnifiedMutate();

  const handleExecute = async () => {
    if (!selectedCompany || !selectedCompany._id || !numberIds || !numberIds.length || isLoading) return;

    const res = await mutate({
      isMyEpik: true,
      endpoint: 'numbers/bulk-assign',
      method: 'PUT',
      body: {
        numberIds,
        companyId: selectedCompany._id,
      },
    });

    if (res && res.success && Array.isArray(res.results)) {
      onAssigned(res);
    }
  };

  return (
    <Modal isOpen={isOpen} className="company-assignment-modal">
      <ModalHeader>Company Assignment</ModalHeader>
      <ModalBody>
        <p className="company-assignment-note">
          Search by company name and select one company. Numbers that are already assigned will not be changed.
        </p>
        <FormGroup>
          <Label for="company-autocomplete-input">Company Name</Label>
          <CompanyAutocomplete
            key={modalKey}
            companies={companies}
            placeholder="Search by Company Name"
            onChange={onCompanyChange}
            onInputChange={onCompanyInputChange}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={onCancel} disabled={isLoading}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleExecute} disabled={!selectedCompany || !selectedCompany._id || isLoading}>
          Execute
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CompanyAssignmentModal;
